import { Form, Modal, Select } from "antd";
import { FormikHelpers, useFormik } from "formik";
import { useEffect, useState } from "react";
import { folderDeleteValidationScheme } from "../../schemas/formValidationScheme";
import TextArea from "antd/es/input/TextArea";
import { resetUpdateStatusState, statusChange } from "../../redux/EngageTranslation/EngageTranslationAction";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { error } from "console";

type FileUploadModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
  currentSelectedStatus: {
    disabled: boolean | undefined;
    key: string;
    label: string;
    title: string | undefined;
    value: string;
  };
  openStatusUpdateSuccessfullyModal: () => void;
  documentId: number;
  docId: number;
  setStatusUpdateSuccessfullyModalOpenState: any;
};

function ConfirmStatusChangeModalContent(props: FileUploadModalProps) {
  const [form] = Form.useForm();
  const updateStatusState = useSelector((state: RootState) => state.engageTranslationState.engageTranslationDetailPageState.updateStatusState);

  const ConfirmStatusChangeModalContentContent = () => {
    const dispatch = useAppDispatch();
    async function handleChange(values: any) {
      const reqEndpointKey = props.currentSelectedStatus.key.toLowerCase();

      await dispatch(
        statusChange({
          reqEndpoint: reqEndpointKey,
          documentId: props.documentId,
          docId: props.docId,
          comments: values.comment,
        })
      );
      props.close();
      props.openStatusUpdateSuccessfullyModal();
    }

    // console.log(errors);
    return (
      <div
        className="d-flex flex-column justify-content-between gap-4 h-100 needs-validation"
        id="createNewFolderForm">
        <h4>Status Update</h4>
        <div className="d-flex flex-column gap-1">
          <div className="d-flex flex-column gap-2">
            <Form
              form={form}
              onFinish={(values) => {
                handleChange(values);
              }}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 19 }}>
              <Form.Item
                label="Status"
                name="status"
                required>
                <Select
                  labelInValue
                  disabled
                  defaultValue={props.currentSelectedStatus}
                  options={[
                    {
                      value: "In Progress",
                      label: "In Progress",
                    },
                    {
                      value: "completed",
                      label: "Completed",
                    },
                    {
                      value: "failed",
                      label: "Failed",
                    },
                    {
                      value: "onHold",
                      label: "On Hold",
                    },
                    {
                      value: "transfer",
                      label: "Transfer",
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label="Comment"
                name="comment"
                rules={[
                  {
                    required: true,
                    message: "Please input your comment!",
                  },
                ]}>
                <TextArea
                  rows={4}
                  placeholder="Please input your comment"
                  showCount
                  maxLength={100}
                />
              </Form.Item>
            </Form>

            {/* <div className="d-flex gap-4 justify-content-end">
              <button
                type="submit"
                form="createNewFolderForm"
                onClick={() => {
                  form.submit();
                }}
                className="button">
                Update
              </button>
              <button
                type="button"
                onClick={() => {
                  props.close();
                }}
                // form="createNewFolderForm"
                className="button warning">
                Cancel
              </button>
            </div> */}
          </div>
        </div>
      </div>
    );
  };
  //   const FileUploadModalWidth = "30%";
  return (
    <Modal
      //   width={FileUploadModalWidth}
      centered
      zIndex={10000}
      confirmLoading={updateStatusState.loading}
      // footer={[]}
      onOk={() => form.submit()}
      destroyOnClose={true}
      afterClose={() => {
        form.resetFields();
      }}
      onCancel={() => {
        props.close();
      }}
      open={props.openState}>
      <ConfirmStatusChangeModalContentContent />
    </Modal>
  );
}

export default ConfirmStatusChangeModalContent;
